<template>
  <v-app-bar app color="primary" dark v-if="!isPublicPage" clipped-left>
    <div class="d-flex align-center mr-10">
      <router-link :to="{ name: 'home' }">
        <v-img alt="Logo" contain :src="logo" width="200" />
      </router-link>
    </div>

    <v-spacer></v-spacer>

    <v-menu offset-y content-class="app-menu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-3 mr-2" icon v-on="on" v-bind="attrs">
          <v-avatar size="44">
            <v-img
              alt="Logo"
              v-if="user"
              contain
              :src="user && user.image"
              width="150"
            />
            <v-icon large v-if="!user"> mdi-account-circle </v-icon>
          </v-avatar>
        </v-btn>
      </template>
      <v-list
        dense
        class="secondary-font list-compressed"
        max-width="250"
        elevation="0"
      >
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title class="primary--text font-weight-bold">
              {{ user && user.name }}
            </v-list-item-title>
            <v-list-item-subtitle class="tiny-text">
              {{ user && user.email }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item :href="user && user.image_download" link>
          <v-list-item-content>
            <v-list-item-title>Download Profile Image</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.prevent="handleLogout">
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import logo from "@/assets/BSE_logo_horizontal_light.png";
export default {
  name: "AppBar",

  data: () => ({
    logo,
  }),
  computed: {
    isPublicPage() {
      return this.$route.meta.publicPage;
    },
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    handleLogout() {
      this.$store.dispatch("auth/logout");
    },
  },
};
</script>
